import { Tab, Tabs } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { useState } from "react";
import ActivationsKeywordExact from "./keyword/exact";
import ActivationsKeywordOther from "./keyword/other";

export default function ActivationsOverview() {
    const theme = useTheme();
    const [tab, setTab] = useState("keywords_exact");

    return (
        <Box>
            {/* Tabs */}
            <Box sx={{ pt: 3 }}>
                <Box
                    sx={{
                        backgroundColor: theme.palette.mode === "dark" ? "#22282F" : "white",
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                        border:
                            theme.palette.mode === "dark"
                                ? "1px solid rgba(255, 255, 255, 0.12)"
                                : "1px solid rgba(145, 158, 171, 0.2)",
                        borderBottom: "none",
                    }}
                >
                    <Tabs
                        sx={{ padding: "16px 32px" }}
                        value={tab}
                        onChange={(_, v) => setTab(v)}
                    >
                        <Tab value="keywords_exact" label="Keyword (Exact)" />
                        <Tab value="keywords_other" label="Keyword (Other)" />

                    </Tabs>
                </Box>
            </Box>

            {tab === "keywords_exact" &&
                <ActivationsKeywordExact />
            }
            
            {tab === "keywords_other" &&
                <ActivationsKeywordOther />
            }
        </Box>
    );
}
